import {
    faAnalytics,
    faArrowLeftFromBracket as fasArrowLeftFromBracket,
    faArrowRight,
    faArrowsRotate as fasArrowsRotate,
    faArrowUpRightAndArrowDownLeftFromCenter as fasArrowUpRightAndArrowDownLeftFromCenter,
    faBan as fasBan,
    faBell,
    faBirthdayCake as fasBirthdayCake,
    faBolt as fasBolt,
    faCalendar,
    faCaretDown,
    faCaretUp,
    faChartLine,
    faCheckCircle,
    faCheckSquare,
    faChevronDown as fasChevronDown,
    faChevronRight as fasChevronRight,
    faChevronUp as fasChevronUp,
    faCircle as fasCircle,
    faCircle,
    faCircleArrowDown as fasCircleArrowDown,
    faCircleArrowLeft as fasCircleArrowLeft,
    faCircleArrowRight as fasCircleArrowRight,
    faCircleArrowUp as fasCircleArrowUp,
    faCircleExclamation as fasCircleExclamation,
    faCircleInfo as fasCircleInfo,
    faCirclePlay as fasCirclePlay,
    faClock as fasClock,
    faClockThree as fasClockThree,
    faCoffee,
    faCog,
    faCopy,
    faDownload as fasDownload,
    faEgg as fasEgg,
    faEllipsisH,
    faEllipsisV,
    faExclamationCircle as fasExclamationCircle,
    faExclamationTriangle as fasExclamationTriangle,
    faFileArrowDown as fasFileArrowDown,
    faFileCsv as fasFileCsv,
    faFolder as fasFolder,
    faGraduationCap as fasGraduationCap,
    faHandPaper as fasHandPaper,
    faHeart as fasHeart,
    faIdCard as fasIdCard,
    faLocationDot as fasLocationDot,
    faMailbox,
    faMapMarker,
    faMedal,
    faMegaphone as fasMegaphone,
    faMessage as fasMessage,
    faMessageQuestion as fasMessageQuestion,
    faMinusCircle as fasMinusCircle,
    faMobile as fasMobile,
    faPaperPlane as fasPaperPlane,
    faPeopleArrows as fasPeopleArrows,
    faPlus as fasPlus,
    faPlusCircle as fasPlusCircle,
    faPrint as fasPrint,
    faQrcode,
    faRedo as fasRedo,
    faRocket as fasRocket,
    faRotate as farRotate,
    faRotateRight as fasRotateRight,
    faSearch as fasSearch,
    faSliders as fasSliders,
    faSort as fasSort,
    faSortDown as fasSortDown,
    faSortUp as fasSortUp,
    faSpinner,
    faSpinnerThird,
    faSquare as farSquare,
    faStar as fasStar,
    faStickyNote,
    faStop as fasStop,
    faTags as fasTags,
    faThumbsDown as fasThumbsDown,
    faThumbsUp as fasThumbsUp,
    faTimesCircle as fasTimesCircle,
    faToggleOff as fasToggleOff,
    faToggleOn as fasToggleOn,
    faTrash as fasTrash,
    faTrashAlt as fasTrashAlt,
    faUpload as fasUpload,
    faUser as fasUser,
    faUserCheck as fasUserCheck,
    faUserClock as fasUserClock,
    faUserHeadset as fasUserHeadset,
    faUsers as fasUsers,
    faUserSlash as fasUserSlash,
    faVideo as fasVideo,
    faVideoSlash as fasVideoSlash,
    faVoteYea,
    faXmark as fasXmark,
} from '@fortawesome/pro-solid-svg-icons'
import {
    faArrowCircleLeft,
    faArrowCircleRight,
    faArrowSquareDown,
    faArrowToBottom,
    faAtomAlt,
    faBars,
    faBook,
    faBorderInner,
    faBullseyeArrow,
    faCamera,
    faCaretLeft,
    faChalkboardTeacher,
    faChevronLeft,
    faChevronRight,
    faCloudUpload,
    faCode,
    faCodeBranch,
    faCommentAltDots,
    faCommentAltExclamation,
    faCommentPlus,
    faCompass,
    faDivide,
    faDrawCircle,
    faEmptySet,
    faExclamationCircle,
    faExternalLink,
    faEye,
    faEyeSlash,
    faFilePdf,
    faFingerprint,
    faFolderOpen,
    faGlobe,
    faGlobeAmericas,
    faLeaf,
    faLink,
    faMegaphone,
    faPalette,
    faPaperPlane,
    faPencil,
    faPlus,
    faPowerOff,
    faRedo,
    faRedoAlt,
    faSave,
    faSchool,
    faSearchMinus,
    faSearchPlus,
    faText,
    faTh,
    faThList,
    faTimes,
    faTrash,
    faUndo,
    faUserCircle,
    faUserGraduate,
    faVideo,
    faAngleDoubleLeft as falAngleDoubleLeft,
    faAngleDoubleRight as falAngleDoubleRight,
    faAngleLeft as falAngleLeft,
    faAngleRight as falAngleRight,
    faArrowRightFromBracket as falArrowRightFromBracket,
    faArrowUpRightFromSquare as falArrowUpRightFromSquare,
    faArrowsRotate as falArrowsRotate,
    faBolt as falBolt,
    faChartLine as falChartLine,
    faCheck as falCheck,
    faCheckCircle as falCheckCircle,
    faCircleExclamation as falCircleExclamation,
    faClock as falClock,
    faCompressWide as falCompressWide,
    faEgg as falEgg,
    faExpandWide as falExpandWide,
    faFileChartColumn as falFileChartColumn,
    faFileContract as falFileContract,
    faHandPaper as falHandPaper,
    faIdCard as falIdCard,
    faMapPin as falMapPin,
    faMinusCircle as falMinusCircle,
    faPlayCircle as falPlayCircle,
    faPlusCircle as falPlusCircle,
    faSearch as falSearch,
    faStar as falStar,
    faTimesCircle as falTimesCircle,
    faToggleOff as falToggleOff,
    faToggleOn as falToggleOn,
    faTrashAlt as falTrashAlt,
    faUndoAlt as falUndoAlt,
    faUserCheck as falUserCheck,
    faUserClock as falUserClock,
    faUserPen as falUserPen,
    faUserPlus as falUserPlus,
    faUserSlash as falUserSlash,
    faUsers as falUsers,
    faWindowMaximize as falWindowMaximize,
    faWindowMinimize as falWindowMinimize,
    faXmark as falXmark,
    faWaveSine as falWaveSine,
} from '@fortawesome/pro-light-svg-icons'
import {
    faArrowUpRightFromSquare,
    faFileCheck,
    faFileDownload,
    faFileUpload,
    faUserSlash,
    faArrowToBottom as farArrowToBottom,
    faBars as farBars,
    faBell as farBell,
    faBookmark as farBookmark,
    faChalkboardTeacher as farChalkboardTeacher,
    faChartLine as farChartLine,
    faChartMixed as farChartMixed,
    faCircleArrowLeft as farCircleArrowLeft,
    faCircleArrowRight as farCircleArrowRight,
    faCircleCheck as farCircleCheck,
    faCircleExclamation as farCircleExclamation,
    faCirclePlay as farCirclePlay,
    faEraser as farEraser,
    faExpandAlt as farExpandAlt,
    faGear as farGear,
    faGlobe as farGlobe,
    faGraduationCap as farGraduationCap,
    faHashtag as farHashtag,
    faHeart as farHeart,
    faLink as farLink,
    faList as farList,
    faLoader as farLoader,
    faMap as farMap,
    faMessage as farMessage,
    faMinusCircle as farMinusCircle,
    faMonitorWaveform as farMonitorWaveform,
    faPenToSquare as farPenToSquare,
    faPeopleGroup as farPeopleGroup,
    faPlusCircle as farPlusCircle,
    faPowerOff as farPowerOff,
    faSearch as farSearch,
    faSpinner as farSpinner,
    faSync as farSync,
    faTag as farTag,
    faTimes as farTimes,
    faToggleLargeOn as farToggleLargeOn,
    faToggleOff as farToggleOff,
    faToggleOn as farToggleOn,
    faUndoAlt as farUndoAlt,
    faUpload as farUpload,
    faUser as farUser,
    faUserCheck as farUserCheck,
    faUserClock as farUserClock,
    faUserHeadset as farUserHeadset,
    faUserPlus as farUserPlus,
    faUsers as farUsers,
    faVideo as farVideo,
    faVideoCircle as farVideoCircle,
    faClock as farClock,
    faWaveSine as farWaveSine,
    faBug as farBug,
} from '@fortawesome/pro-regular-svg-icons'
import { faFacebook, faInstagram, faWhatsapp } from '@fortawesome/free-brands-svg-icons'

import { faUserCog } from '@fortawesome/pro-duotone-svg-icons'
// Importo y creo librería FA para uso global. Agregar iconos acá.
import { library } from '@fortawesome/fontawesome-svg-core'

export default library.add(
    faAnalytics,
    faArrowCircleLeft,
    faArrowCircleRight,
    faArrowRight,
    faArrowSquareDown,
    faArrowToBottom,
    faArrowUpRightFromSquare,
    faAtomAlt,
    fasBan,
    faBars,
    faBell,
    faBook,
    faBorderInner,
    faBullseyeArrow,
    faCalendar,
    faCamera,
    faCaretDown,
    faCaretLeft,
    faCaretUp,
    faChalkboardTeacher,
    faChartLine,
    faCheckCircle,
    faCheckSquare,
    faChevronLeft,
    faChevronRight,
    faCircle,
    faCloudUpload,
    faCode,
    faCodeBranch,
    faCoffee,
    faCog,
    faCommentAltDots,
    faCommentAltExclamation,
    faCommentPlus,
    faCompass,
    faCopy,
    faDivide,
    faDrawCircle,
    faEllipsisH,
    faEllipsisV,
    faEmptySet,
    faExclamationCircle,
    faExternalLink,
    faEye,
    faEyeSlash,
    faFacebook,
    faFileCheck,
    faFileDownload,
    faFilePdf,
    faFileUpload,
    faFingerprint,
    faFolderOpen,
    faGlobe,
    faGlobeAmericas,
    faInstagram,
    falAngleDoubleLeft,
    falAngleDoubleRight,
    falAngleLeft,
    falAngleRight,
    falArrowRightFromBracket,
    falArrowsRotate,
    falArrowUpRightFromSquare,
    falBolt,
    falChartLine,
    falCheck,
    falCheckCircle,
    falCircleExclamation,
    falClock,
    falCompressWide,
    faLeaf,
    falEgg,
    falExpandWide,
    falFileChartColumn,
    falFileContract,
    falHandPaper,
    falIdCard,
    faLink,
    falMapPin,
    falMinusCircle,
    falPlayCircle,
    falPlusCircle,
    falSearch,
    falStar,
    falTimesCircle,
    falToggleOff,
    falToggleOn,
    falTrashAlt,
    falUndoAlt,
    falUserCheck,
    falUserClock,
    falUserPen,
    falUserPlus,
    falUsers,
    falUserSlash,
    falWaveSine,
    falWindowMaximize,
    falWindowMinimize,
    falXmark,
    faMailbox,
    faMapMarker,
    faMedal,
    faMegaphone,
    faPalette,
    faPaperPlane,
    faPencil,
    faPlus,
    faPowerOff,
    faQrcode,
    farArrowToBottom,
    farBars,
    farBell,
    farBookmark,
    farBookmark,
    farBug,
    farChalkboardTeacher,
    farChartLine,
    farChartMixed,
    farCircleArrowLeft,
    farCircleArrowRight,
    farCircleCheck,
    farCircleExclamation,
    farCirclePlay,
    farClock,
    faRedo,
    faRedoAlt,
    farEraser,
    farExpandAlt,
    farGear,
    farGlobe,
    farGraduationCap,
    farHashtag,
    farHeart,
    farLink,
    farList,
    farLoader,
    farMap,
    farMessage,
    farMinusCircle,
    farMonitorWaveform,
    farPenToSquare,
    farPeopleGroup,
    farPlusCircle,
    farPowerOff,
    farRotate,
    farSearch,
    farSpinner,
    farSquare,
    farSync,
    farTag,
    farTimes,
    farToggleLargeOn,
    farToggleOff,
    farToggleOn,
    farUndoAlt,
    farUpload,
    farUser,
    farUserCheck,
    farUserClock,
    farUserHeadset,
    farUserPlus,
    farUsers,
    farVideo,
    farVideo,
    farVideoCircle,
    farWaveSine,
    fasArrowLeftFromBracket,
    fasArrowsRotate,
    fasArrowLeftFromBracket,
    fasArrowUpRightAndArrowDownLeftFromCenter,
    faSave,
    fasBan,
    fasBirthdayCake,
    fasBolt,
    fasChevronDown,
    fasChevronRight,
    fasChevronUp,
    faSchool,
    fasCircle,
    fasCircleArrowDown,
    fasCircleArrowLeft,
    fasCircleArrowRight,
    fasCircleArrowUp,
    fasCircleExclamation,
    fasCircleInfo,
    fasCirclePlay,
    fasClock,
    fasClockThree,
    fasDownload,
    faSearchMinus,
    faSearchPlus,
    fasEgg,
    fasExclamationCircle,
    fasExclamationTriangle,
    fasFileArrowDown,
    fasFileCsv,
    fasFolder,
    fasGraduationCap,
    fasHandPaper,
    fasHeart,
    fasIdCard,
    fasLocationDot,
    fasMegaphone,
    fasMessage,
    fasMessageQuestion,
    fasMinusCircle,
    fasMobile,
    fasPaperPlane,
    fasPeopleArrows,
    faSpinner,
    faSpinnerThird,
    fasPlus,
    fasPlusCircle,
    fasPrint,
    fasRedo,
    fasRocket,
    fasRotateRight,
    fasSearch,
    fasSliders,
    fasSort,
    fasSortDown,
    fasSortUp,
    fasStar,
    fasStop,
    fasTags,
    fasThumbsDown,
    fasThumbsUp,
    faStickyNote,
    fasTimesCircle,
    fasToggleOff,
    fasToggleOn,
    fasTrash,
    fasTrashAlt,
    fasUpload,
    fasUser,
    fasUserCheck,
    fasUserClock,
    fasUserHeadset,
    fasUsers,
    fasUserSlash,
    fasVideo,
    fasVideoSlash,
    fasXmark,
    faText,
    faTh,
    faThList,
    faTimes,
    faTrash,
    faUndo,
    faUserCircle,
    faUserCog,
    faUserGraduate,
    faUserSlash,
    faVideo,
    faVoteYea,
    faWhatsapp
)
